<template>
  <span class="inline-flex items-center gap-2 whitespace-nowrap">
    <span
      v-if="showIcon"
      class="iconify fa-pro-light--envelope text-base"
    />
    <a :href="LINK_TYPE_HREF.MAIL + emailAddress">
      {{ emailAddress }}
    </a>
  </span>
</template>

<script lang="ts">

import { LINK_TYPE_HREF } from '~~/constants/html';

export default defineComponent({
  name: 'EmailAddress',
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
    emailAddress: {
      type: String,
      required: true,
    },
  },
  setup() {

    return {
      LINK_TYPE_HREF,
    };
  
  },
});

</script>
